import styled from 'styled-components';

import { DEFAULT_COLORS } from 'constants/colors';

export const MobileBreadcrumbWrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    margin 2rem 0 1.5rem 0;
`;

export const MobileStepHeader = styled.div`
    display: flex;
    align-items: center;
    text-align: center;
    outline: none;
    cursor: pointer;
    flex-direction: column;
    padding: 0;
`;

export const MobileStepIndicator = styled.div`
    position: relative;
    top: 0;
    right: 0;
    order: 1;
    width: 1.375rem;
    height: 1.375rem;
    background-color: ${DEFAULT_COLORS.STEEL};
    z-index: 2;
    transition: transform 0.2s ease;
    margin: 0 auto 0 auto;
    &:before {
        display: none;
        content: ' ';
        position: absolute;
        left: 0;
        top: 100%;
        width: 0;
        height: 0;
        border-left: 0.688rem solid transparent;
        border-right: 0.688rem solid transparent;
        border-top: 0.688rem solid ${DEFAULT_COLORS.STEEL};
    }
    &[type='completed'] {
        background-color: ${DEFAULT_COLORS.GREEN};
    }
    &[type='error'] {
        background-color: ${DEFAULT_COLORS.RED};
    }
    &[type='current'] {
        background-color: ${DEFAULT_COLORS.BLUE};
        &:before {
            display: block;
            border-top-color: ${DEFAULT_COLORS.BLUE};
        }
    }
`;

export const MobileStepLabel = styled.div`
    font-size: 1.125rem;
    line-height: 1;
    width: 100%;
    display: none;
    position: relative;
    margin-top: 1rem;
    order: 2;
    &[type='current'] {
        display: block;
    }
`;

export const MobileStepStyled = styled.div`
    position: relative;
    &::before {
        content: '';
        display: none;
    }
    &::after {
        content: '';
        width: 100%;
        height: 0.1875rem;
        position: absolute;
        background-color: ${DEFAULT_COLORS.DARK};
        top: 0.6875rem;
        left: -50%;
        z-index: 0;
        transform: translateY(-50%);
    }
    &:last-of-type,
    &#lastStep {
        &::before {
            display: none;
        }
    }
    width: 25%;
    text-align: center;
    &:first-child:after {
        content: none;
    }
`;

export const StepStyled = styled.div`
    position: relative;
    &::before {
        content: '';
        display: block;
        height: 100%;
        width: 0.1562rem;
        position: absolute;
        right: 0.625rem;
        top: 0.3125rem;
        background-color: ${DEFAULT_COLORS.LIGHT};
        z-index: 1;
    }
    &:last-of-type,
    &#lastStep {
        &::before {
            display: none;
        }
    }
`;

export const StepHeader = styled.div`
    display: flex;
    align-items: center;
    text-align: right;
    padding-bottom: 3.25rem;
    padding-right: 2.375rem;
    outline: none;
    cursor: pointer;
`;

export const StepLabel = styled.div`
    font-size: 1.125rem;
    line-height: normal;
    width: 100%;
`;

export const StepIndicator = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    width: 1.375rem;
    height: 1.375rem;
    background-color: ${DEFAULT_COLORS.DARK};
    border-radius: 100%;
    z-index: 3;
    transition: transform 0.2s ease;
    &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 0.813rem;
        height: 0.813rem;
        background-color: ${DEFAULT_COLORS.WHITE};
        opacity: 0.5;
        border-radius: 100%;
    }
    &:hover {
        transform: scale(1.25);
        box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.15);
    }
    &[type='completed'] {
        background-color: ${DEFAULT_COLORS.GREEN};
    }
    &[type='error'] {
        background-color: ${DEFAULT_COLORS.RED};
    }
    &[type='current'] {
        background-color: ${DEFAULT_COLORS.BRAND_BLUE_2};
    }
`;
